import React from "react";
import styled from "styled-components";

const StarCitizenLogo = styled.img`
    width: 128px;
    background: #212b17;
    padding: 13px 8px 13px 14px;
    border-radius: 3px;
`;

const StarCitizenReferralButton = ({referralCode}) => (
    <a href={"https://robertsspaceindustries.com/enlist?referral=" + referralCode}>
        <StarCitizenLogo src="/images/STARCITIZEN_HORIZONTAL_WHITE.png" alt="Join Star Citizen" title="Join Star Citizen" />
    </a>
);

export default StarCitizenReferralButton;